import service from "@/tools/request";
import defaultRequestErrorHandle from "@/plug/request/defaultErrorHandle";
export function wechatLogin({ openid }) {
  return service({
    url: '/login',
    method: 'post',
    data: {
      openid
    }
  }).catch(defaultRequestErrorHandle)
}